module.exports = __webpack_public_path__ + "img/SL7_4726-Bearbeitet.136003a0.jpg";